import { render, staticRenderFns } from "./ConcentrationTile.vue?vue&type=template&id=ab201298&"
import script from "./ConcentrationTile.vue?vue&type=script&lang=js&"
export * from "./ConcentrationTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports